import type { RootState } from "../typings"

export const selectAppearance = (state: RootState) => state.appSettings.appearance

export const selectThemePalette = (state: RootState) => state.appSettings.themePalette
